import styled from '@emotion/styled'
import Video from '../../panels/Video'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'

const SectionContainer = styled.div`
  display: flex;
  align-items: stretch;
  background-color: ${(props) => (props.BackgroundColor ? props.BackgroundColor : '#fff;')};
  flex-direction: ${(props) => (props.reverse ? 'row-reverse' : 'row')};
  color: ${(props) => (props.Color ? props.Color : '#000')};
  @media (max-width: 1025px) {
    flex-direction: ${(props) => (props.reverseMobile ? 'column-reverse' : 'column')};
  }
`

const SectionCopy = styled.div`
  overflow: hidden;
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${(props) => (props.contentSection ? `gap: 50px; padding: 50px 30px;` : '')}
  @media (max-width: 1280px) {
    ${(props) => (props.contentSection ? `padding-right: 10px; padding-left: 10px;` : '')}
  }
  @media (max-width: 1025px) {
    width: 100%;
  }
`

const HeaderVideo = styled(Video)`
  width: 50%;
  @media (max-width: 1025px) {
    width: 100%;
  }
`

const HeaderImage = styled(GatsbyImage)`
  width: 100%;
  max-height: 800px;
  min-height: 100%;
  @media (max-width: 1025px) {
    width: 100%;
    max-height: 100vw;
  }
`

const Heading = styled.h1`
  display: flex;
  font-size: 46px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -1.11px;
  padding: 8px 0;
  justify-content: center;
  display: flex;
  text-align: center;
  @media (max-width: 1025px) {
    font-size: 32px;
    justify-content: center;
  }
  @media (max-width: 640px) {
    font-size: 25px;
  }
`

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  text-align: center;
`

const ContentItem = styled.div`
  flex: 1;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 50px;
  align-items: center;
  @media (max-width: 1024px) {
    gap: 40px;
  }
`

const Title = styled.h4`
  font-size: 20px;
  padding: 12px 24px;
  border-radius: 9999px;
  color: ${(props) => (props.color ? props.color : '#fff')};
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : '')};
  box-sizing: border-box;

  @media (max-width: 1280px) {
    font-size: 18px;
    padding: 10px 20px;
  }

  @media (max-width: 640px) {
    font-size: 16px;
    padding: 10px 20px;
  }
`

const Description = styled.div`
  max-width: 300px;
  font-size: 18px;

  @media (max-width: 1280px) {
    font-size: 16px;
  }

  @media (max-width: 640px) {
    font-size: 14px;
  }
`

const SplitPanelV3 = ({ data }) => {
  const { image, BackgroundColor, reverse, reverseMobile, Color, Content } = data

  return (
    <SectionContainer
      BackgroundColor={BackgroundColor}
      reverse={reverse}
      reverseMobile={reverseMobile}
      Color={Color}
    >
      <SectionCopy>
        {image &&
          image?.file &&
          (image?.mime?.includes('video') || image?.mime?.includes('gif') ? (
            <HeaderVideo alt={image?.alternativeText || image?.name} src={image?.file?.publicURL} />
          ) : (
            <HeaderImage
              loading="lazy"
              alt={image?.alternativeText || image?.name}
              image={withArtDirection(getImage(image?.file?.childImageSharp?.gatsbyImageData), [
                {
                  media: '(max-width: 1024px)',
                  image: getImage(image?.file?.childImageSharp?.gatsbyImageDataMobile),
                },
              ])}
            />
          ))}
      </SectionCopy>
      <SectionCopy contentSection>
        {data.Heading && <Heading>{data.Heading}</Heading>}
        {Content && (
          <ContentContainer>
            {Content.map((item, index) => (
              <ContentItem key={index}>
                <Title color={BackgroundColor} backgroundColor={Color}>
                  {item.title}
                </Title>
                <Description dangerouslySetInnerHTML={{ __html: item.description }} />
              </ContentItem>
            ))}
          </ContentContainer>
        )}
      </SectionCopy>
    </SectionContainer>
  )
}

export default SplitPanelV3
